// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-l_gV","advertDetailContacts__header":"c-l_gW"};